import React from 'react';
import ReactSelect from 'react-select';
import { Controller } from 'react-hook-form';

import Field from './field';
import 'react-select/dist/react-select.css';

export default (props) => {
    const {
        fieldKey,
        options,
        defaultValue,
        required,
        className,
        control,
        multi = false
    } = props;

    return (
        <Field
            {...props}
            inputComp={
                <div data-ta={`${fieldKey}`}>
                    <Controller
                        name={fieldKey}
                        control={control}
                        defaultValue={ defaultValue }
                        render={({ field }) => (
                            <ReactSelect
                                { ...field }
                                type="text"
                                multi={multi}
                                className={ className }
                                closeOnSelect={ multi !== true }
                                clearable={ false }
                                id={ fieldKey }
                                options={ options }
                            />
                        )}
                    />
                </div>
            }
        />
    );
};
